/* eslint-disable arrow-body-style */
import { API, Auth, Logger } from 'aws-amplify';

const logger = new Logger('OCSApiService.js');
const OCS_API_NAME = 'OCSApiProxy';

/**
 * Request Options to include authorization headers on all requests
 */
const requestOptions = () => {
  logger.debug('requestOptions..');
  return Auth.currentAuthenticatedUser()
    .then((user) => {
      return {
        headers: {
          'Content-Type': 'application/json',
          'x-api-authorization': `Bearer ${user.signInUserSession.accessToken.jwtToken}`,
        },
      };
    })
    .catch((error) => {
      logger.error('User is not authenticated ', error);
      throw error;
    });
};

/**
 * Request Wrapper to call the request options on all requests
 * @param {*} request
 */
const requestWrapper = (request) => {
  return requestOptions().then((options) => request(options));
};

const putPurchaseOrder = (buyerId, poId, body) => {
  return requestWrapper((options) => {
    // make api request
    Object.assign(options, { body });
    return API.put(OCS_API_NAME, `/buyers/${buyerId}/purchaseOrders/${poId}`, options);
  });
};

const getPurchaseOrder = (buyerId, poId) => {
  return requestWrapper((options) => {
    // make api request
    Object.assign(options);
    return API.get(OCS_API_NAME, `/buyers/${buyerId}/purchaseOrders/${poId}`, options);
  });
};

const getAllPurchaseOrders = (buyerId) => {
  return requestWrapper((options) => {
    // make api request
    Object.assign(options);
    return API.get(OCS_API_NAME, `/buyers/${buyerId}/purchaseOrders`, options);
  });
};

const getPurchaseOrders = (buyerId, params) => {
  return requestWrapper((options) => {
    //?vendorId=&arrivalDateFrom=&arrivalDateTo=&customerId=?,?&loadDateFrom=&loadDateTo=
    let {
      startDate,
      endDate,
      dateType,
      customerCode,
      vendorCode,
    } = params;
    // format date types
    const fromDateParam = dateType === "0"
      ? 'loadDateFrom'
      : 'arrivalDateFrom';
    const toDateParam = dateType === "0"
      ? 'loadDateTo'
      : 'arrivalDateTo'

    // form url and queryParams
    const url = `/buyers/${buyerId}/purchaseOrders?vendorId=${vendorCode}&customerId=${customerCode}`;
    let queryParams = startDate
      ? `&${fromDateParam}=${startDate}`
      : '';
    queryParams = endDate
      ? `${queryParams}&${toDateParam}=${endDate}`
      : queryParams;

    return API.get(OCS_API_NAME, `${url}${queryParams}`, options);

    //return API.get(OCS_API_NAME, `/buyers/${buyerId}/purchaseOrders?vendorCode=${vendorCode}&arrivalDateFrom=2020-08-01&customerCode=DCM`, options);
  });
}

const deletePurchaseOrder = (buyerId, poId) => {
  return requestWrapper((options) => {
    // make api request
    Object.assign(options);
    return API.del(OCS_API_NAME, `/buyers/${buyerId}/purchaseOrders/${poId}`, options);
  });
};

export {
  requestWrapper,
  putPurchaseOrder,
  getPurchaseOrder,
  deletePurchaseOrder,
  getAllPurchaseOrders,
  getPurchaseOrders
};
